import {
  addReviewerCommittee,
  cancelProtocolCommittee,
  cancelReviewer as doCancelReviewer,
  createReviewerDictumTask as createReviewerTask,
  fetchAssignedReviewerDictums,
  fetchAssignedReviewers,
  fetchCommittees,
  fetchDateDictumCommittee,
  fetchDictums,
  fetchDictumTypes,
  fetchProtocolTaskAdvance,
  fetchReviewerDictums,
  fetchReviewerInvitation,
  fetchReviewersCommittee,
  replyReviewerInvite,
  resendInvitation,
  saveCommitteeDictum as saveProtocolCommitteeDictum,
  saveDateDictumCommittee,
  saveReviewerDictum as saveRevDictum,
} from './api'

const saveDateDictum = async({ commit }, payload) => {
  try {
    return await saveDateDictumCommittee(payload)
  } catch (e) {
    console.error(e)
  }
}

const saveCommitteeDictum = async({ commit }, payload) => {
  return await saveProtocolCommitteeDictum(payload)
}

const getDateDictum = async({ commit }, payload) => {
  const page     = payload.page ? payload.page : 1
  const pageSize = payload.pageSize ? payload.pageSize : 20
  const {
          query,
          protocol_id,
          committee_id,
        }        = payload
  
  let dates = []
  
  try {
    const response = (await fetchDateDictumCommittee({
      query,
      pageSize,
      page,
      protocol_id,
      committee_id,
    }))
    
    dates = response.data.data
    
    if (page > 1) {
      dates = state.dates.concat(dates)
    }
    
    commit('SET_DATES', dates)
    
    return response.data
  } catch (e) {
    console.error(e)
  }
}

const getCommittees = async({
  commit,
  state,
}, payload) => {
  const {
          query,
          key,
        } = payload
  
  let committees = []
  
  try {
    committees = (await fetchCommittees({
      query,
      key,
    })).data.data
    
    commit('SET_COMMITTEES', committees)
    
    return committees
  } catch (e) {
    console.error(e)
  }
}

const getReviewers = async({
  commit,
  state,
}, payload) => {
  const page     = payload.page ? payload.page : 1
  const pageSize = payload.pageSize ? payload.pageSize : 20
  const {
          query,
          committee,
          protocol,
        }        = payload
  
  let reviewers = []
  
  try {
    reviewers = (await fetchReviewersCommittee({
      query,
      pageSize,
      page,
      committee,
      protocol,
    })).data.data
    
    if (page > 1) {
      reviewers = state.reviewers.concat(reviewers)
    }
    
    commit('SET_PROTOCOL_REVIEWERS', reviewers)
    
    return reviewers
  } catch (e) {
    console.error(e)
  }
}

const getDictumTypes = async({
  commit,
  state,
}, payload) => {
  const {
          query,
          keyList,
          committee,
          protocol,
        } = payload
  
  let dictumTypes = []
  
  try {
    dictumTypes = (await fetchDictumTypes({
      query,
      keyList,
      committee: committee.id,
      protocol: protocol.id,
    })).data.data
    
    commit('SET_DICTUM_TYPES', dictumTypes)
    
    return dictumTypes
  } catch (e) {
    console.error(e)
  }
}

const getDictums = async({
  commit,
  state,
}, payload) => {
  const page     = payload.page ? payload.page : 1
  const pageSize = payload.pageSize ? payload.pageSize : 20
  
  const {
          query,
          protocol,
          committee,
          ...data
        } = payload
  
  let dictums = []
  
  try {
    const response = (await fetchDictums({
      query,
      pageSize,
      page,
      protocol_id: protocol.id,
      committee_id: committee ? committee.id : null,
      ...data
    }))
    
    dictums = response.data.data
    
    if (page > 1) {
      dictums = state.dictums.concat(dictums)
    }
    
    commit('SET_DICTUMS', dictums)
    
    return response.data
  } catch (e) {
    console.error(e)
  }
}

const getCommitteeDictums = async({
  commit,
  state,
}, payload) => {
  const {
          protocol,
          committee,
        } = payload
  
  let dictums = []
  
  try {
    const response = (await fetchDictums({
      protocol_id: protocol.id,
      committee_id: committee ? committee.id : null,
    }))
    
    dictums = response.data.data
    
    commit('SET_COMMITEE_DICTUMS', dictums)
    
    return dictums
  } catch (e) {
    console.error(e)
  }
}

const getAssignedReviewers = async({
  commit,
  state,
}, payload) => {
  const page     = payload.page ? payload.page : 1
  const pageSize = payload.pageSize ? payload.pageSize : 20
  
  const {
          query,
          protocol,
          committee,
          amendment,
        } = payload
  
  let assignedReviewers = []
  
  try {
    assignedReviewers = (await fetchAssignedReviewers({
      query,
      pageSize,
      page,
      protocol: protocol.id,
      committee: committee.id,
      amendment: amendment ? amendment.id : null,
    })).data.data
    
    if (page > 1) {
      assignedReviewers = state.assignedReviewers.concat(assignedReviewers)
    }
    
    commit('SET_ASSIGNED_REVIEWERS', assignedReviewers)
    
    return assignedReviewers
  } catch (e) {
    console.error(e)
  }
}

const getAssignedReviewerDictums = async({
  commit,
  state,
}, payload) => {
  const page     = payload.page ? payload.page : 1
  const pageSize = payload.pageSize ? payload.pageSize : 20
  
  const {
          query,
          protocol,
          committee,
        } = payload
  
  let assignedReviewerDictums = []
  
  try {
    assignedReviewerDictums = (await fetchAssignedReviewerDictums({
      query,
      pageSize,
      page,
      protocol: protocol.id,
      committee: committee.id,
    })).data.data
    
    if (page > 1) {
      assignedReviewerDictums = state.assignedReviewerDictums.concat(assignedReviewerDictums)
    }
    
    commit('SET_ASSIGNED_REVIEWER_DICTUMS', assignedReviewerDictums)
    
    return assignedReviewerDictums
  } catch (e) {
    console.error(e)
  }
}

const getProtocolTaskAdvance = async({
  commit,
  state,
}, payload) => {
  const {
          query,
          protocol,
          committee,
        } = payload
  
  let protocolTaskAdvance = {}
  
  try {
    protocolTaskAdvance = (await fetchProtocolTaskAdvance({
      query,
      protocol_id: protocol,
      committee_id: committee,
    })).data.data
    
    commit('SET_PROTOCOL_TASK_ADVANCE', protocolTaskAdvance)
    
    return protocolTaskAdvance
  } catch (e) {
    throw e
  }
}

const addReviewer = async({ commit }, payload) => {
  try {
    const response = await addReviewerCommittee(payload)
    
    commit('SET_PROTOCOL_REVIEWERS', response.data.data.researchers)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const cancelProtocol = async({ commit }, payload) => {
  try {
    const response = await cancelProtocolCommittee(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const getReviewerInvitation = async({ commit }, payload) => {
  try {
    const response = await fetchReviewerInvitation(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const getReviewerDictums = async({ commit }, payload) => {
  try {
    const response = await fetchReviewerDictums(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const replyInvite = async({ commit }, payload) => {
  try {
    const response = await replyReviewerInvite(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const saveReviewerDictum = async({ commit }, payload) => {
  try {
    return await saveRevDictum(payload)
  } catch (e) {
    console.error(e)
    
    return e
  }
}

const cancelReviewer = async({ commit }, payload) => {
  try {
    return await doCancelReviewer(payload)
  } catch (e) {
    console.error(e)
    
    return e
  }
}

const resendInvitationReviewer = async({ commit }, payload) => {
  try {
    return await resendInvitation(payload)
  } catch (e) {
    console.error(e)
    
    return e
  }
}

const createReviewerDictumTask = async({ commit }, payload) => {
  try {
    return await createReviewerTask(payload)
  } catch (e) {
    console.error(e)
    
    return e
  }
}

export default {
  saveDateDictum,
  saveCommitteeDictum,
  getDateDictum,
  getCommittees,
  getReviewers,
  getDictumTypes,
  getDictums,
  getCommitteeDictums,
  getAssignedReviewers,
  getAssignedReviewerDictums,
  getProtocolTaskAdvance,
  addReviewer,
  cancelProtocol,
  getReviewerInvitation,
  getReviewerDictums,
  replyInvite,
  saveReviewerDictum,
  cancelReviewer,
  resendInvitationReviewer,
  createReviewerDictumTask
}
